module.exports = {
    appversionAndroid: '1.0.0',
    appversioniOS: '1.0.0',
    appUpdateMessageAndroid: true,
    appUpdateMessageiOS: true,
}